import { render, staticRenderFns } from "./index-lectures.vue?vue&type=template&id=07024c68&scoped=true&"
import script from "./index-lectures.vue?vue&type=script&lang=js&"
export * from "./index-lectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07024c68",
  null
  
)

export default component.exports